import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-orange-50 via-pink-50 to-yellow-50">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative h-screen flex items-center justify-center bg-cover bg-center overflow-hidden"
        style={{
          backgroundImage: `linear-gradient(135deg, rgba(236, 72, 153, 0.7), rgba(251, 146, 60, 0.7), rgba(234, 179, 8, 0.7)), url('https://public.readdy.ai/ai/img_res/584335dd130cf35cb79233bab0fe9d0f.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-black/10 to-transparent"></div>
        <div className="container mx-auto px-6 text-center text-white z-10 relative">
          <div className="inline-block mb-6 px-6 py-2 bg-white/20 backdrop-blur-sm rounded-full border-2 border-white/40">
            <p className="text-lg font-semibold">✨ Where Creativity Comes Alive ✨</p>
          </div>
          <h1 className="text-6xl md:text-8xl font-bold mb-6 drop-shadow-2xl" style={{ fontFamily: '"Pacifico", serif' }}>
            Tenny & Co Artistry
          </h1>
          <p className="text-2xl md:text-4xl mb-4 font-bold drop-shadow-lg">
            Port Harcourt's Premier Art & Design Brand
          </p>
          <p className="text-xl md:text-2xl mb-10 max-w-3xl mx-auto drop-shadow-lg font-medium">
            We bring your vision to life through exceptional art, graphic design, storytelling, and educational content. From stunning portraits to captivating brand designs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-10 py-5 rounded-full text-lg font-bold transition-all cursor-pointer shadow-2xl transform hover:scale-105"
            >
              🎨 Get Started Today
            </Link>
            <Link 
              to="/portfolio" 
              className="whitespace-nowrap bg-white hover:bg-gray-50 text-orange-600 px-10 py-5 rounded-full text-lg font-bold transition-all cursor-pointer shadow-2xl transform hover:scale-105 border-4 border-white"
            >
              ✨ View Our Work
            </Link>
          </div>
        </div>
        
        {/* Floating Art Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-yellow-400 rounded-full opacity-60 animate-bounce"></div>
        <div className="absolute bottom-32 right-20 w-16 h-16 bg-pink-400 rounded-full opacity-60 animate-pulse"></div>
        <div className="absolute top-1/3 right-10 w-12 h-12 bg-orange-400 rounded-full opacity-60 animate-bounce" style={{ animationDelay: '0.5s' }}></div>
      </section>

      {/* Services Overview */}
      <section className="py-20 bg-gradient-to-br from-yellow-100 via-orange-100 to-pink-100 relative overflow-hidden">
        <div className="absolute top-0 left-0 w-64 h-64 bg-orange-300 rounded-full opacity-20 -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-pink-300 rounded-full opacity-20 translate-x-1/3 translate-y-1/3"></div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="text-6xl">🎨</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">Our Services</h2>
            <p className="text-2xl text-gray-700 max-w-2xl mx-auto font-semibold">
              We have got much to offer - from traditional art to digital design
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            <Link to="/art-paintings" className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="bg-gradient-to-br from-orange-400 to-red-500 rounded-3xl p-8 hover:shadow-2xl transition-all h-full text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg relative z-10">
                  <i className="ri-brush-line text-4xl text-orange-500"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4 relative z-10">Art & Paintings</h3>
                <p className="text-white/90 mb-4 text-lg relative z-10">
                  Pencil portraits, canvas paintings, wall murals, and digital illustrations crafted with precision and passion.
                </p>
                <span className="text-white font-bold inline-flex items-center text-lg relative z-10">
                  Explore Gallery <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </span>
              </div>
            </Link>

            <Link to="/graphic-design" className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="bg-gradient-to-br from-pink-400 to-rose-500 rounded-3xl p-8 hover:shadow-2xl transition-all h-full text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg relative z-10">
                  <i className="ri-palette-line text-4xl text-pink-500"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4 relative z-10">Graphic Design</h3>
                <p className="text-white/90 mb-4 text-lg relative z-10">
                  Posters, flyers, social media graphics, business ads, and elegant brand layouts that capture attention.
                </p>
                <span className="text-white font-bold inline-flex items-center text-lg relative z-10">
                  View Designs <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </span>
              </div>
            </Link>

            <Link to="/storytelling" className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="bg-gradient-to-br from-yellow-400 to-orange-500 rounded-3xl p-8 hover:shadow-2xl transition-all h-full text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg relative z-10">
                  <i className="ri-video-line text-4xl text-yellow-500"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4 relative z-10">Storytelling</h3>
                <p className="text-white/90 mb-4 text-lg relative z-10">
                  Artful Tales with Tennyson - Engaging bedtime stories and creative content on YouTube.
                </p>
                <span className="text-white font-bold inline-flex items-center text-lg relative z-10">
                  Watch Stories <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </span>
              </div>
            </Link>

            <Link to="/education" className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="bg-gradient-to-br from-teal-400 to-green-500 rounded-3xl p-8 hover:shadow-2xl transition-all h-full text-white relative overflow-hidden">
                <div className="absolute top-0 right-0 w-32 h-32 bg-white/10 rounded-full -translate-y-1/2 translate-x-1/2"></div>
                <div className="w-20 h-20 bg-white rounded-full flex items-center justify-center mb-6 shadow-lg relative z-10">
                  <i className="ri-book-open-line text-4xl text-teal-500"></i>
                </div>
                <h3 className="text-3xl font-bold mb-4 relative z-10">Education</h3>
                <p className="text-white/90 mb-4 text-lg relative z-10">
                  Cultural and Creative Arts teaching materials, lesson notes, and educational support for students.
                </p>
                <span className="text-white font-bold inline-flex items-center text-lg relative z-10">
                  Learn More <i className="ri-arrow-right-line ml-2 group-hover:translate-x-2 transition-transform"></i>
                </span>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Featured Work */}
      <section className="py-20 bg-gradient-to-br from-pink-100 via-orange-100 to-yellow-100 relative">
        <div className="absolute inset-0 opacity-30">
          <div className="absolute top-10 left-20 w-40 h-40 bg-orange-300 rounded-full blur-3xl"></div>
          <div className="absolute bottom-20 right-20 w-60 h-60 bg-pink-300 rounded-full blur-3xl"></div>
          <div className="absolute top-1/2 left-1/2 w-80 h-80 bg-yellow-300 rounded-full blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-6 relative z-10">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="text-6xl">✨</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-pink-600 to-orange-600 bg-clip-text text-transparent">Featured Work</h2>
            <p className="text-2xl text-gray-700 font-semibold">A glimpse into our creative excellence</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="overflow-hidden rounded-3xl shadow-2xl border-8 border-white bg-white">
                <img 
                  src="https://readdy.ai/api/search-image?query=stunning%20realistic%20pencil%20portrait%20drawing%20of%20african%20person%20detailed%20shading%20professional%20artwork%20on%20white%20paper%20hyperrealistic%20facial%20features%20artistic%20charcoal%20sketch%20with%20dramatic%20lighting%20fine%20art%20portrait%20photography%20style%20clean%20simple%20background&width=600&height=800&seq=featured-portrait-1&orientation=portrait"
                  alt="Portrait Art"
                  className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="mt-6 text-center">
                <div className="inline-block bg-gradient-to-r from-orange-500 to-pink-500 text-white px-6 py-2 rounded-full mb-2">
                  <h3 className="text-xl font-bold">Portrait Mastery</h3>
                </div>
                <p className="text-gray-700 font-semibold text-lg">Lifelike pencil portraits</p>
              </div>
            </div>

            <div className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="overflow-hidden rounded-3xl shadow-2xl border-8 border-white bg-white">
                <img 
                  src="https://readdy.ai/api/search-image?query=vibrant%20colorful%20abstract%20canvas%20painting%20with%20bold%20brushstrokes%20modern%20contemporary%20art%20piece%20with%20rich%20textures%20acrylic%20paint%20on%20canvas%20artistic%20composition%20with%20warm%20colors%20professional%20fine%20art%20photography%20clean%20simple%20background&width=600&height=800&seq=featured-painting-2&orientation=portrait"
                  alt="Canvas Painting"
                  className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="mt-6 text-center">
                <div className="inline-block bg-gradient-to-r from-pink-500 to-rose-500 text-white px-6 py-2 rounded-full mb-2">
                  <h3 className="text-xl font-bold">Canvas Creations</h3>
                </div>
                <p className="text-gray-700 font-semibold text-lg">Original paintings</p>
              </div>
            </div>

            <div className="group cursor-pointer transform hover:scale-105 transition-all">
              <div className="overflow-hidden rounded-3xl shadow-2xl border-8 border-white bg-white">
                <img 
                  src="https://readdy.ai/api/search-image?query=modern%20professional%20graphic%20design%20poster%20with%20elegant%20typography%20clean%20layout%20vibrant%20colors%20business%20event%20flyer%20design%20contemporary%20brand%20identity%20visual%20minimalist%20aesthetic%20professional%20marketing%20material%20clean%20simple%20background&width=600&height=800&seq=featured-design-3&orientation=portrait"
                  alt="Graphic Design"
                  className="w-full h-96 object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="mt-6 text-center">
                <div className="inline-block bg-gradient-to-r from-yellow-500 to-orange-500 text-white px-6 py-2 rounded-full mb-2">
                  <h3 className="text-xl font-bold">Brand Design</h3>
                </div>
                <p className="text-gray-700 font-semibold text-lg">Professional graphics</p>
              </div>
            </div>
          </div>

          <div className="text-center mt-12">
            <Link 
              to="/portfolio" 
              className="whitespace-nowrap inline-block bg-gradient-to-r from-orange-500 to-pink-500 hover:from-orange-600 hover:to-pink-600 text-white px-10 py-5 rounded-full text-xl font-bold transition-all cursor-pointer shadow-2xl transform hover:scale-105"
            >
              🎨 View Full Portfolio
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-20 bg-gradient-to-br from-orange-50 via-pink-50 to-yellow-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <div className="inline-block mb-4">
              <span className="text-6xl">🏆</span>
            </div>
            <h2 className="text-5xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-orange-600 to-pink-600 bg-clip-text text-transparent">Why Choose TCA</h2>
            <p className="text-2xl text-gray-700 font-semibold">Excellence in every stroke, pixel, and word</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 border-4 border-orange-200">
              <div className="w-24 h-24 bg-gradient-to-br from-orange-400 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-award-line text-5xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-orange-600">Professional Quality</h3>
              <p className="text-gray-600 text-lg">
                Every project is executed with meticulous attention to detail and professional standards that exceed expectations.
              </p>
            </div>

            <div className="text-center bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 border-4 border-pink-200">
              <div className="w-24 h-24 bg-gradient-to-br from-pink-400 to-rose-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-time-line text-5xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-pink-600">Timely Delivery</h3>
              <p className="text-gray-600 text-lg">
                We respect your time and ensure all projects are completed within agreed timelines without compromising quality.
              </p>
            </div>

            <div className="text-center bg-white rounded-3xl p-10 shadow-xl hover:shadow-2xl transition-all transform hover:scale-105 border-4 border-yellow-200">
              <div className="w-24 h-24 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-customer-service-2-line text-5xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-4 text-yellow-600">Client Satisfaction</h3>
              <p className="text-gray-600 text-lg">
                Your vision is our priority. We work closely with you to bring your ideas to life exactly as you imagined.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 via-pink-500 to-rose-500 relative overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute top-0 left-0 w-96 h-96 bg-yellow-400 rounded-full opacity-20 -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-orange-400 rounded-full opacity-20 translate-x-1/2 translate-y-1/2 blur-3xl"></div>
        </div>
        
        <div className="container mx-auto px-6 text-center text-white relative z-10">
          <div className="inline-block mb-6">
            <span className="text-7xl">🎨</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold mb-6 drop-shadow-lg">Ready to Bring Your Vision to Life?</h2>
          <p className="text-2xl mb-10 max-w-2xl mx-auto drop-shadow-lg font-medium">
            Let's create something extraordinary together. Contact us today for a consultation.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link 
              to="/contact" 
              className="whitespace-nowrap bg-white hover:bg-gray-50 text-orange-600 px-10 py-5 rounded-full text-xl font-bold transition-all cursor-pointer shadow-2xl transform hover:scale-105"
            >
              📧 Contact Us Now
            </Link>
            <a 
              href="tel:08162117807" 
              className="whitespace-nowrap bg-transparent hover:bg-white/20 text-white border-4 border-white px-10 py-5 rounded-full text-xl font-bold transition-all cursor-pointer shadow-2xl transform hover:scale-105"
            >
              📞 Call: 08162117807
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}